import openSocket from "socket.io-client";
import config from "../config";
import auth from "./auth";
export const socket = auth.isAuthenticated ? openSocket(config.__SOCKET__IP,{transports: ['polling']}) : [];



// WEBPACK FOOTER //
// ./src/helpers/socketHelper.js